import { z } from 'zod';
import { IdSchema, type Id, type TableName } from './records';

export type Op =
  | { t: 'create'; table: TableName; rec: Record<string, unknown> & { id: Id } }
  | { t: 'delete'; table: TableName; rec: Record<string, unknown> & { id: Id } }
  | {
      t: 'update';
      table: TableName;
      id: Id;
      before: Record<string, unknown>;
      after: Record<string, unknown>;
    };

export const SourceSchema = z.object({
  kind: z.enum(['user', 'module', 'system']),
  id: z.string().optional(),
});
export type Source = z.infer<typeof SourceSchema>;

const TableSchema = z.enum(['objects', 'links']);
const RecSchema = z.record(z.unknown()).and(z.object({ id: IdSchema }));

export const OpSchema: z.ZodType<Op> = z.union([
  z.object({ t: z.literal('create'), table: TableSchema, rec: RecSchema }),
  z.object({ t: z.literal('delete'), table: TableSchema, rec: RecSchema }),
  z.object({
    t: z.literal('update'),
    table: TableSchema,
    id: IdSchema,
    before: z.record(z.unknown()),
    after: z.record(z.unknown()),
  }),
]) as z.ZodType<Op>;

export interface Transaction {
  id: Id;
  canvasId: Id;
  ts: number;
  source: Source;
  label?: string;
  ops: Op[];
  /** Module ids whose objects/links were touched (§12.3). */
  modules: string[];
  undoOf?: Id;
  redoOf?: Id;
}

export const TransactionSchema = z.object({
  id: IdSchema,
  canvasId: IdSchema,
  ts: z.number(),
  source: SourceSchema,
  label: z.string().optional(),
  ops: z.array(OpSchema),
  modules: z.array(z.string()),
  undoOf: IdSchema.optional(),
  redoOf: IdSchema.optional(),
});
